<template>
    
<div>

       <footer class="footer-area">
    <div class="container">
        <div class="row">
            <!--Start single footer widget-->
            <div class="col-lg-8 col-md-2 col-sm-6 col-xs-12">
                <div class="single-footer-widget Statistic-pdbottom">
                    <div class="footer-logo" style="text-align:left;">
                        <img :src=" this.serverurl+this.logo" alt="Awesome Footer Logo" style="width: 250px; height: 60px;">
                     
                    </div>
                    <div class="statistic-info">
                        
                        
                        <p v-html="this.footer_texten"  v-if="$i18n.locale=='en'">{{ footer_texten }}</p>
                         <p  v-html="this.footer_textar" v-else dir="rtl">{{ footer_textar }}</p>
                    </div>
                    <ul class="footer-social-links">
                        <li><a href="https://www.facebook.com/Wafrafx/"><i aria-hidden="true" class="fa fa-facebook"></i></a></li>
                        <li><a href="https://twitter.com/wafrafx"><i aria-hidden="true" class="fa fa-twitter"></i></a></li>
                        <li><a href="https://www.youtube.com/channel/UCOGqjV7nnQbIWnuiqXYr8yA?view_as=subscriber"><i aria-hidden="true" class="fa fa-youtube"></i></a></li>
                        <li><a href="https://www.instagram.com/wafrafx/"><i aria-hidden="true" class="fa fa-instagram"></i></a></li>
                    </ul>
                </div>
            </div>
            <!--End single footer widget-->
            <!--Start single footer widget-->
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                <div class="single-footer-widget">
                    <div class="contact-address">
                        <div style="background-color:#f9f9f9!important;" id="contact-address-carousel" class="carousel slide" data-ride="carousel">
                            <ol class="carousel-indicators">
                                <li data-target="#contact-address-carousel" data-slide-to="0" class="active"></li>
                                <li data-target="#contact-address-carousel" data-slide-to="1"></li>
                                <li data-target="#contact-address-carousel" data-slide-to="2"></li>
                            </ol>
                            <div class="carousel-inner" role="listbox">
                                <div class="item active">
                                    <div class="single-contact-address">
                                        <ul>
                                           <li class="title">{{ $i18n.locale == 'en' ? footercontacts1titleen :footercontacts1titlear }}</li>
                                            <li>
                                                <div class="icon-holder map">
                                                    <span class="flaticon-signs"></span>    
                                                </div>
                                                <div class="content-holder">
                                                    <p v-html="$i18n.locale == 'en' ? footercontacts1address_en :footercontacts1address_en">{{ $i18n.locale == 'en' ? footercontacts1address_en :footercontacts1address_ar }}</p>    
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon-holder">
                                                    <span class="flaticon-phone-call"></span>    
                                                </div>
                                                <div class="content-holder">
                                                    <p>{{ $i18n.locale == 'en' ? footercontacts1phone :footercontacts1phone }}</p>    
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon-holder">
                                                    <span class="flaticon-e-mail-envelope"></span>    
                                                </div>
                                                <div class="content-holder">
                                                    <p>{{ $i18n.locale == 'en' ? footercontacts1email :footercontacts1email }}</p>    
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon-holder">
                                                    <span class="flaticon-clock"></span>    
                                                </div>
                                                <div class="content-holder">
                                                    <p>{{ $i18n.locale == 'en' ? footercontacts1workinghours_en :footercontacts1workinghours_en }}</p>    
                                                </div>
                                            </li>
                                        </ul>    
                                    </div>
                                </div>
                                <div class="item"  v-for="footercontactsitems in footercontactslist.slice(1)" :key="footercontactsitems.id">
                                    <div class="single-contact-address">
                                        <ul>
                                           <li class="title">{{ $i18n.locale == 'en' ? footercontactsitems.titleen :footercontactsitems.titlear }}</li>
                                            <li>
                                                <div class="icon-holder map">
                                                    <span class="flaticon-signs"></span>    
                                                </div>
                                                <div class="content-holder">
            <p v-html="$i18n.locale == 'en' ? footercontactsitems.address_en :footercontactsitems.address_ar">{{ $i18n.locale == 'en' ? footercontactsitems.address_en :footercontactsitems.address_ar }}</p>    
    
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon-holder">
                                                    <span class="flaticon-phone-call"></span>    
                                                </div>
                                                <div class="content-holder">
                                                    <p>{{ $i18n.locale == 'en' ? footercontactsitems.phone :footercontactsitems.phone }}</p>    
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon-holder">
                                                    <span class="flaticon-e-mail-envelope"></span>    
                                                </div>
                                                <div class="content-holder">
                                                    <p>{{ $i18n.locale == 'en' ? footercontactsitems.email :footercontactsitems.email }}</p>    
                                                </div>
                                            </li>
                                            <li>
                                                <div class="icon-holder">
                                                    <span class="flaticon-clock"></span>    
                                                </div>
                                                <div class="content-holder">
                                                    <p>{{ $i18n.locale == 'en' ? footercontactsitems.workinghours_en :footercontactsitems.workinghours_ar }}</p>    
                                                </div>
                                            </li>
                                        </ul>    
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <!--End single footer widget-->
        </div>
    </div>
</footer>   
<!--End footer area--> 
<!--Start footer bottom area-->
<section class="footer-bottom-area">
    <div class="container">
         <ul class="footer-menu" v-if="$i18n.locale=='en'">
             <li><a :href="'../../../../en/risk'">Risk-Warning</a></li>
					<li><a :href="'../../../../en/privacy'">Privacy And Security Policy</a></li> 
					<li><a :href="'../../../../en/disclaimer'">Disclaimer</a></li>
					<li><a :href="'../../../../en/terms'">Terms And Conditions</a></li>
                    <li><a :href="'../../../../en/orders'">Orders Execution Policy</a></li>   
					<li><a :href="'../../../../en/aml'">AML</a></li>  
					<li><a :href="'../../../../en/tradingconditions'">Trading Conditions</a></li>
             </ul>
                
        
                <ul class="footer-menu" v-else>
					<li><a :href="'../../../../ar/tradingconditions'">شروط التداول</a></li>
                    <li><a :href="'../../../../ar/aml'">مكافحة غسيل الأموال</a></li>    
                    <li><a :href="'../../../../ar/orders'">سياسة و تنفيذ الأوامر</a></li>    
                    <li><a :href="'../../../../ar/terms'">الشروط و الأحكام</a></li>    
                    <li><a :href="'../../../../ar/discalimer'">إخلاء المسؤولية</a></li>    
                    <li><a :href="'../../../../ar/privacy'">سياسة الخصوصية و الأمان</a></li>      
                    <li><a :href="'../../../../ar/risk'">تحذير المخاطر</a></li>      
                </ul>   
            </div>
</section>   
<!--End footer bottom area-->
	<!--Start footer bottom area-->
<section class="footer-bottom-area">
    <div class="container" style="color: #404040">
        <p  v-if="$i18n.locale=='en'">{{copyrighten}}</p>
        
                <p v-else dir="rtl" style="color: #404040; text-align: right;">{{copyrightar}}</p>
            </div>
</section>   
<!--End footer bottom area-->
<!--Scroll to top-->
<div class="scroll-to-top scroll-to-target" data-target="html"><span class="fa fa-angle-up"></span></div>
    </div>

</template>
<script>
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery-1.11.1.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/bootstrap.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.bxslider.min.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.countTo.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.appear.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/owl.carousel.min.js";

import  "https://wafrafrontend.marketequityinc.com/src/assets/js/validate.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.mixitup.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.easing.min.js";
import "http://maps.google.com/maps/api/js?sensor=true";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/gmaps.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/js/map-helper.js";

import "https://wafrafrontend.marketequityinc.com/src/assets/js/jquery.fitvids.js";


import "https://wafrafrontend.marketequityinc.com/src/assets/fancyapps-fancyBox/source/jquery.fancybox.pack.js";		

import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/jquery.themepunch.tools.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/jquery.themepunch.revolution.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.actions.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.carousel.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.kenburn.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.layeranimation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.migration.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.navigation.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.parallax.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.slideanims.min.js";
import "https://wafrafrontend.marketequityinc.com/src/assets/assets/revolution/js/extensions/revolution.extension.video.min.js";




import "https://wafrafrontend.marketequityinc.com/src/assets/js/custom.js";
</script>

<style>
    .accordion-box .accordion .accord-btn h4{
        padding-right: 5%;
    }
</style>
<script>

export default {
    name: 'footer',
    data() {
        return {

            riskwarningen: null,
            riskwarningar: null,
            riskwarningfr: null,
            riskwarningch: null,
            riskwarningru: null,

            supportnumber: null,
            supportemail: null,
            copyrighten: null,
            copyrightar: null,
           
            footerbg:null,
            locale: 'en',
            mainmenus:'',
            submenus:'',
            lanflag:'en',
            pathname:'',
            footer_texten:'',
            footer_textar:'',
            footercontactslist:'',
            footercontacts1titleen:'',
            footercontacts1titlear:'',
            footercontacts1workinghours_en:'',
            footercontacts1workinghours_ar:'',
            footercontacts1address_en:'',
            footercontacts1address_ar:'',
            footercontacts1phone:'',
            footercontacts1email:'',


        }
    },

    created() {
        // document.title = "Look Ma!";
        this.lanflag=this.$i18n.locale;
        if (this.$i18n.locale == 'العربية') {
            this.lanflag='ar';
        }
          
    },
    beforeMount() {

        this.loaddata();

        this.loadmenus();

        this.footercontacts();

        var pathvalues=(this.$route.path).split("/");

        this.pathname=pathvalues[2];
        this.lanflag=this.$i18n.locale;
        if (this.$i18n.locale == 'العربية') {
            this.lanflag='ar';
        }
        

    },

    methods: {
       
        loaddata() {

            this.$axios.get("loadheaderdata",
            )
                .then(res => {
                    if (res) {
                        this.sitesettings=res.data.sitesettings[0];
                        this.logo = res.data.sitesettings[0].logo;
                        this.sitetitleen = res.data.sitesettings[0].sitetitleen;
                        this.sitetitlear = res.data.sitesettings[0].sitetitlear;
                         this.sitetitleen = res.data.sitesettings[0].sitetitleen;
                        this.footer_texten = res.data.sitesettings[0].footer_texten;
                        this.footer_textar = res.data.sitesettings[0].footer_textar;
                        this.riskwarningen = res.data.sitesettings[0].riskwarningen;
                        this.riskwarningar = res.data.sitesettings[0].riskwarningar;
                       
                        this.supportnumber = res.data.sitesettings[0].supportnumber;
                        this.supportemail = res.data.sitesettings[0].supportemail;
                        
                          this.copyrighten = res.data.sitesettings[0].copyrighten;
                        this.copyrightar = res.data.sitesettings[0].copyrightar;
                     
                        this.footerbg = res.data.sitesettings[0].footerimage;
                    }
                });
        },
        langchange(lang) {

            this.$i18n.locale = lang;
            if (lang == 'en') {
                document.title = this.sitetitleen;
                document.dir = "ltr";


            }
            if (lang == 'العربية') {
                document.title = this.sitetitlear;
                document.dir = "rtl";
            }
           
        },
        loadmenus() {

            this.$axios.get("loadmenus",
            )
                .then(res => {
                    if (res) {

                        this.mainmenus = res.data.mainmenus;
                        this.submenus = res.data.submenus;


                    }
                });
        },
        
         footercontacts() {

            this.$axios.get("loadfootercontacts",
            )
                .then(res => {
                    if (res) {

                        this.footercontactslist = res.data.footercontacts;
                       

                        this.footercontacts1titleen = res.data.footercontacts[0].titleen;
                        this.footercontacts1titlear = res.data.footercontacts[0].titlear;
                        this.footercontacts1workinghours_en = res.data.footercontacts[0].workinghours_en;
                        this.footercontacts1workinghours_ar = res.data.footercontacts[0].workinghours_ar;
                        this.footercontacts1address_en = res.data.footercontacts[0].address_en;
                        this.footercontacts1address_ar = res.data.footercontacts[0].address_ar;
                        this.footercontacts1phone = res.data.footercontacts[0].phone;
                       this.footercontacts1email = res.data.footercontacts[0].email;
                    }
                });
        },


    }

}

</script>



